export default __webpack_public_path__ + "static/icon-21-6-31d732cfb592e3295159583b80811642.png";